import './MembershipMemberSearchBar.css';

type MembershipMemberSearchBarProps = {
  query: string;
  typeUuid?: string;
  typeOptions?: Array<{ value: string; label: string }>;
  onQueryChange: (query: string) => void;
  onTypeChange?: (typeUuid: string) => void;
};

const MembershipMemberSearchBar = ({
  query,
  typeUuid,
  typeOptions = [],
  onQueryChange,
  onTypeChange
}: MembershipMemberSearchBarProps) => (
  <div className="membership-member-search">
    <div className="membership-member-search__input-wrapper">
      <span className="membership-member-search__search-icon" aria-hidden="true">
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
          <circle cx="7" cy="7" r="5.5" stroke="currentColor" strokeWidth="1.5" />
          <path d="M11 11l3.5 3.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
        </svg>
      </span>
      <input
        className="input membership-member-search__input"
        placeholder="Search by name or phone"
        value={query}
        onChange={(event) => onQueryChange(event.target.value)}
      />
    </div>
    {typeOptions.length > 0 ? (
      <div className="membership-member-search__chips" aria-label="Filter members by tier">
        <button
          type="button"
          className={`membership-member-search__chip ${!typeUuid ? 'is-active' : ''}`}
          onClick={() => onTypeChange?.('')}
        >
          All
        </button>
        {typeOptions.map((option) => (
          <button
            key={option.value}
            type="button"
            className={`membership-member-search__chip ${typeUuid === option.value ? 'is-active' : ''}`}
            onClick={() => onTypeChange?.(option.value)}
          >
            {option.label}
          </button>
        ))}
      </div>
    ) : null}
  </div>
);

export default MembershipMemberSearchBar;
